import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppDataResolver } from './app.resolver';

export const routes: Routes = [
  { path: 'creditnote', loadChildren: './credit-note/credit-note.module#CreditNoteModule', resolve: { data: AppDataResolver } },
  { path: 'writeoff', loadChildren: './write-off/write-off.module#WriteOffModule', resolve: { data: AppDataResolver } },
  { path: 'latefees', loadChildren: './late-fees/late-fees.module#LateFeesModule', resolve: { data: AppDataResolver } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
